import React, { useMemo } from 'react';
import { useResponsive } from '@common-fe/common-fe';
import { Grommet as CommonGrommet } from '@common-fe/common-fe';
import { Grommet } from 'grommet';
import _ from 'lodash';

import { useCombinedTheme } from '@/modules/core/hooks/useCombinedTheme';

interface Props {
  children: React.ReactNode;
}

const MobileResponsiveWrapper: React.FC<Props> = ({ children }) => {
  const { isMobile } = useResponsive();

  if (isMobile) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const combinedTheme = useCombinedTheme();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const mobileTheme = useMemo(() => {
      if (isMobile) {
        return _.merge(_.cloneDeep(combinedTheme), {
          controls: {
            height: '48px',
            buttons: {
              height: {
                height: '48px',
              },
            },
          },
          input: {
            common: {
              'min-height': '48px',
            },
          },
          height: {
            input: { height: '48px' },
          },
          formFieldsEdging: {
            padding: '12px',
            outline: '8px solid #F7F9FA',
            borderRadius: '12px',
            margin: '0px',
          },
          global: {
            edgeSize: {
              ...{
                moduleRound: combinedTheme.rounds.moduleRound !== '0px' ? '12px' : undefined,
              },
            },
            size: {
              medium: '100%',
            },
          },
          rounds: {
            ...{
              moduleRound: combinedTheme.rounds.moduleRound !== '0px' ? '12px' : undefined,
            },
          },
        });
      }
    }, [combinedTheme, isMobile]);
    return (
      <CommonGrommet key="mobile-theme-1" theme={mobileTheme}>
        <Grommet key="mobile-theme-2" theme={mobileTheme}>
          {children}
        </Grommet>
      </CommonGrommet>
    );
  }

  return children;
};

export default MobileResponsiveWrapper;
